<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name color-71aa3f">
                    Reset Password
                </div>
                <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="back">Back</button>
            </div>
            <div class="admin-page-content">
                <form id="callfrom">
                    <div class="forms-container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="row no-margin">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                <div class="alert alert-success" id="alertSuccess">
                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                    <span>Password successfully changed.</span>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                <div class="alert alert-danger" id="alertError">
                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                    <span id="errorMsg" class="error"></span>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label"><strong>Old Password</strong></div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="password" id="oldpassword" name="oldpassword" class="form-control"
                                           placeholder="Enter Old Password" v-model="oldpassword" v-validate="'required'">
                                    <div class="requiredstar">*</div>
                                    <span v-show="errors.has('oldpassword')" class="help is-danger"><font color="red">Old Password Required</font></span>
                                </div>    
                            </div>
                            <div class="clearfix"></div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label"><strong>New Password</strong></div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="password" id="newpassword" ref="newpassword" name="newpassword" class="form-control"
                                           placeholder="Enter Old Password" v-model="newpassword" v-validate="'required'">
                                    <div class="requiredstar">*</div>
                                    <span v-show="errors.has('newpassword')" class="help is-danger"><font color="red">New Password Required</font></span>
                                </div>    
                            </div>
                            <div class="clearfix"></div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label"><strong>Confirm Password</strong></div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="password" id="confirmpassword" name="confirmpassword" class="form-control"
                                           placeholder="Enter Confirm Password" v-model="confirmpassword" v-validate="'confirmed:newpassword|required'">
                                    <div class="requiredstar">*</div>
                                    <span v-show="errors.has('confirmpassword')" class="help is-danger"><font color="red">Password Does Not Match</font></span>
                                </div>    
                            </div>
                            <div class="clearfix"></div>
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <button type="button" class="btn general-button btn-primary" v-on:click="changePassword()" id='resetPassword'>Reset Password</button>
                                    <!--<button type="button" class="btn bg-pink waves-effect" v-on:click="">MY SELF</button>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!--<div class="container-fluid">
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card form-header-task">
                        <div class="body full-task-main">
                            <form >
                                <div class="clearfix col-xs-12 col-sm-12">
                                    <div class="btn-group btn-group-lg" role="group" aria-label="Large button group">

                                    </div>
                                </div>
                                <div class="clearfix"></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
        <app-footer></app-footer>
    </div>

</template>
<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    Vue.component('v-select', vSelect);
    import FrontFooter from '@/components/partials/FrontFooter';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    import SessioMixin from '../mixins/sessionmixin';

    var segments = '';
    export default {
        name: "callCreate",
        components: {
            'app-footer': FrontFooter,
        },
        mixins: [SessioMixin],
        data() {
            return{
                oldpassword: '',
                newpassword: '',
                confirmpassword: '',
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            }
        },

        mounted: function () {

            var self = this;

        },

        methods: {
            back: function () {
                var self = this;
                self.$router.push("/listcustomer")
            },

            changePassword: function () {
                this.$validator.validate().then(result => {
                    if (result) {
                        var self = this;
                        self.showLoader();
                        $("#resetPassword").html('Changing ...');
                        $("#resetPassword").prop('disabled', true);
                        $.ajax({
                            url: process.env.ROOT_API + "/changepassword",
                            type: "POST",
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            data: {
                                oldPassword: self.oldpassword,
                                newPassword: self.newpassword,
                                confirmpassword: self.confirmpassword,
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.hideLoader();
                                $("#resetPassword").html('Reset Password');
                                $("#resetPassword").prop('disabled', false);
                                if (data.status == "success") {
                                    self.oldpassword = self.newpassword = self.confirmpassword = '';
                                    $('#oldpassword').val('');
                                    $('#newpassword').val('');
                                    $('#confirmpassword').val('');
                                    $(".alert-success").parent().removeClass('hide');
                                    $(".alert-success").parent().addClass('show');
                                    setTimeout(function () {
                                        $('.alert-success').parent().removeClass('show');
                                        $('.alert-success').parent().addClass('hide');
                                    }, 5000);
                                } else {
                                    $("#errorMsg").html(data.message);
                                    $(".alert-danger").parent().removeClass('hide');
                                    $(".alert-danger").parent().addClass('show');
                                    setTimeout(function () {
                                        $('.alert-danger').parent().removeClass('show');
                                        $('.alert-danger').parent().addClass('hide');
                                    }, 5000);
                                }
                                // console.log(self.customerArr.data());
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                $("#resetPassword").html('Reset Password');
                                $("#resetPassword").prop('disabled', false);
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-danger").parent().removeClass('hide');
                                $(".alert-danger").parent().addClass('show');
                                setTimeout(function () {
                                    $('.alert-danger').parent().removeClass('show');
                                    $('.alert-danger').parent().addClass('hide');
                                }, 5000);
                            }
                        });

                    }
                });

            },

            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ChangePassword.vue